import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Alert,
  CircularProgress,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { UpdateRole } from "../../redux/actions/UpdateRoleAction";

const EditRoleModal = ({ open, onClose, roleData }) => {
  const dispatch = useDispatch();
  const status = useSelector((state) => state.updateRole.status);
  const [form, setForm] = useState({
    idrole: "",
    roleName: "",
    isActive: true,
    addToAll: false,
    countryId: "",
  });
  const [message, setMessage] = useState({ type: "", text: "" });
  const loading = status === "loading";

  useEffect(() => {
    if (roleData && open) {
      setForm({
        idrole: roleData.idrole ?? "",
        roleName: roleData.roleName ?? "",
        isActive: roleData.isActive ?? false,
        addToAll: roleData.addToAll ?? false,
        countryId: roleData.countryId ?? "",
      });
      setMessage({ type: "", text: "" });
    }
  }, [roleData, open]);

  const isFormValid = () =>
    form.idrole !== "" && form.roleName.trim() !== "";

  const handleClose = () => {
    onClose();
  };

  const handleSave = async () => {
    setMessage({ type: "", text: "" });

    try {
      const result = await dispatch(UpdateRole(form));

      if (result.success) {
        setMessage({ type: "success", text: result.message });
        setTimeout(() => {
          handleClose();
        }, 1500);
      } else {
        setMessage({ type: "error", text: result.message });
      }
    } catch {
      setMessage({
        type: "error",
        text: "There was an error updating the role. Please try again.",
      });
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Role</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
          <TextField
            label="ID"
            value={form.idrole}
            fullWidth
            disabled
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="Role Name"
            value={form.roleName}
            onChange={(e) => setForm({ ...form, roleName: e.target.value })}
            fullWidth
            required
            disabled={loading}
          />
          <FormControlLabel
            control={
              <Switch
                checked={form.isActive}
                onChange={(e) =>
                  setForm({ ...form, isActive: e.target.checked })
                }
                disabled={loading}
              />
            }
            label="Active"
          />
          <FormControlLabel
            control={
              <Switch
                checked={form.addToAll}
                onChange={(e) =>
                  setForm({ ...form, addToAll: e.target.checked })
                }
                disabled={loading}
              />
            }
            label="Add To All"
          />

          {message.text && (
            <Alert
              severity={message.type}
              onClose={() => setMessage({ type: "", text: "" })}
            >
              {message.text}
            </Alert>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={!isFormValid() || loading}
          startIcon={
            loading ? <CircularProgress size={20} color="inherit" /> : null
          }
          sx={{
            backgroundColor: "#4b4bfa",
            "&:hover": { backgroundColor: "#3e3ed9" },
            color: "#fff",
          }}
        >
          {loading ? "Saving..." : "Save Changes"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditRoleModal;
